export const generateFilterRoadmapItemsQueryVariables = (
	sourceAri: string,
	quickFilterIds?: string[],
	customFilterIds?: string[],
) => ({
	sourceAri,
	quickFilterIds,
	customFilterIds,
});
